import React, { Suspense } from "react";
import { Redirect, Route, Switch, useLocation, matchPath } from "react-router";
import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Loader from "./components/Loader";
import Seo from "./components/Seo";
import SnackbarComponent from "./components/snackbar";
import routes from "./routes";

function RouteSeo() {
  const { pathname } = useLocation();
  const active = routes.find((r) =>
    matchPath(pathname, { path: r.path, exact: r.exact })
  );
  const brand = pathname.startsWith("/products/")
    ? decodeURIComponent(pathname.split("/")[2] || "").replace(/-/g, " ")
    : "";
  const seo = active && active.seo ? { ...active.seo } : {};

  if (active?.name === "Products" && brand) {
    const formattedBrand = brand.replace(/\b\w/g, (letter) => letter.toUpperCase());
    seo.title = `${formattedBrand} HVAC, Plumbing & Firefighting Products`;
    seo.description = `Browse ${formattedBrand} HVAC, plumbing and firefighting products supplied by N S Solution in Surat, India.`;
  }

  return <Seo {...seo} path={pathname} />;
}

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <div className="App container_12">
        <a className="skip-link" href="#main">Skip to main content</a>
        <RouteSeo />
        <Header />
        <Switch>
          {routes.map((route, i) => (
            <Route
              key={i}
              component={route.component}
              path={route.path}
              exact={route.exact}
            />
          ))}
          <Redirect to="/404" />
        </Switch>
        <SnackbarComponent />
        <Footer />
      </div>
    </Suspense>
  );
}

export default App;
